import { RootState } from "../redux/reducers";
import { store } from "../redux/store";
import httpService from "./httpService";
import { CheckOnboardingDto, StripeConnectLoginLink } from "./model/marketplace.model";

export async function createMerchantAccount(): Promise<CheckOnboardingDto> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .post<CheckOnboardingDto>(`/marketplace/account`, { businessId: selectedBusiness })
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function checkOnboarding(): Promise<CheckOnboardingDto> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<CheckOnboardingDto>(`/marketplace/account/${selectedBusiness}`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function getLoginToDashBoardLoginLink(): Promise<StripeConnectLoginLink> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<StripeConnectLoginLink>(`/marketplace/account/${selectedBusiness}/login`)
        .then((res) => res.data)
        .catch((err) => {
            if (err.response.status === 401) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}

export async function checkMandateStatusForUser(userId: number): Promise<boolean> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<boolean>(`/marketplace/account/${selectedBusiness}/mandate/${userId}`)
        .then(() => true)
        .catch(() => false);
}

export async function getAccountBalance(): Promise<number> {
    const { selectedBusiness } = (store.getState() as RootState).application;
    return httpService
        .get<{balance: number}>(`/marketplace/account/${selectedBusiness}/balance`)
        .then((res) => res.data.balance)
        .catch((err) => {
            if (err.response.status === 401 || err.response.status === 403) {
                throw new Error("UNAUTHORIZED");
            }
            throw err;
        });
}